import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';

const state = {
    briefs: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    filtroPeriodo: true,
    filtroNumero: false,
    filtroPresupuesto: false,
    fechaDesde: moment(new Date()).add(-365, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    numero: 0,
    cliente: null,
    numeroPI: 0,
    incluirCerrados: false,
    sortByDescending: true,

    briefSearch: {},
    existsBrief: false,
    searchList: [],

    list: [],

    briefId: 0,
    usuarios: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.briefs = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.filtroPeriodo = true;
        state.filtroNumero = false;
        state.filtroPresupuesto = false;
        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.numero = 0;
        state.cliente = null;
        state.numeroPI = 0;
        state.incluirCerrados = false;
        state.sortByDescending = true;
    },

    'INICIALIZAR_BRIEFS' (state) {
        state.briefs = [];
    },
    'SET_BRIEFS' (state, briefs) {
        state.briefs = briefs;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_SEARCH' (state) {
        state.briefSearch = {};
    },
    'SET_BRIEF_SEARCH' (state, briefSearch) {
        state.briefSearch = briefSearch;
    },

    'INICIALIZAR_SEARCH_LIST' (state) {
        state.searchList = {};
    },
    'SET_SEARCH_LIST' (state, list) {
        state.searchList = list;
    },

    'INICIALIZAR_VALIDACION_EXISTS' (state) {
        state.existsBrief = false;
    },
    'SET_VALIDACION_EXISTS' (state, existsBrief) {
        state.existsBrief = existsBrief;
    },

    'INICIALIZAR_SELECCION_USUARIOS' (state, briefId) {
        state.briefId = briefId;
        state.usuarios = [];
    },
    'SET_SELECCION_USUARIOS' (state, usuarios) {
        state.usuarios = usuarios.sort(function(a, b){
            /* Ordenamos por condición de inactivo */
            if (!a.inactivo & b.inactivo) {
                return -1;
            }
            if (a.inactivo & !b.inactivo) {
                return 1;    
            }
            /* Ordenamos por estado de Asignado */
            if (a.asignado & !b.asignado) {
                return -1;
            }
            if (!a.asignado & b.asignado) {
                return 1;    
            }
            /* Ordenamos por Rol y Nombre */
            let x = a.usuarioRol.toLowerCase().trim() + ' ' + a.usuario.toLowerCase().trim();
            let y = b.usuarioRol.toLowerCase().trim() + ' ' + b.usuario.toLowerCase().trim();
            if (x < y) { 
                return -1; 
            }
            if (x > y) {
                return 1;
            }
            return 0;
        });
    },

    'INICIALIZAR_LIST' (state) {
        state.list = [];
    },
    'SET_LIST' (state, list) {
        state.list = list;
    },

};

const getters = {
    getField,

    briefSearch(state) {
        return state.briefSearch;
    },
    existsBrief(state) {
        return state.existsBrief;
    },
    searchList(state) {
        return state.searchList;
    },
    list(state) {
        return state.list;
    }
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
    getBriefs ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_BRIEFS');

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;

            if ((/true/i).test(state.filtroNumero)) {
                if (state.numero != 0) {
                    queryString += '&numero=' + state.numero;
                } else {
                    queryString += '&numero=-1';
                }
            } else if ((/true/i).test(state.filtroPresupuesto)) {
                if (state.numeroPI != 0) {
                    queryString += '&presupuestoNumero=' + state.numeroPI;
                }
                if (state.numeroPI == 0) {
                    queryString += '&presupuestoNumero=-1';
                }
            } else {
                queryString += '&fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                    + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD')
                    + '&sortByDescending='+ state.sortByDescending;

                if (state.cliente) {
                    if (state.cliente.id != 0) {
                        queryString += '&clienteId=' + state.cliente.id;
                    }
                }
                if ((/true/i).test(state.incluirCerrados)) {
                    queryString += '&incluirCerrados=true';
                }
            }
                
            apiAxios.get('briefs' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }

                    commit('SET_BRIEFS', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    addCambios ( {}, params ) {
        return new Promise((resolve, reject) => {
            let cambios = {
                observaciones: params.observaciones
            }

            apiAxios.post(`briefs/${params.briefId}/cambios/add`, cambios)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    sendNotificacionesCambios ({}, briefId) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`briefs/${briefId}/send-notificaciones`)
                .then(res => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    searchBriefByNumero ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_SEARCH');

            let query = '?numero=' + params.numero;

            // if (params.clienteId) {
            //     if (params.clienteId != 0) {
            //         query += '&clienteId=' + params.clienteId;
            //     }
            // }
            
            apiAxios.get('briefs/search' + query) 
                .then(res => {
                    let status = parseInt(res.status);

                    if (status == 200) {
                        commit('SET_BRIEF_SEARCH', res.data);
                        resolve();
                    } else if (status == 204) {
                        reject('No se encontró el brief con el número ingresado.');
                    } else {
                        reject('Se produjo un error al recuperar la información del brief.');
                    }
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    cerrarBrief ( {}, briefId) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`briefs/${briefId}/cerrar`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    abrirBrief ( {}, briefId) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`briefs/${briefId}/abrir`)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    cancelarBrief ( {}, params) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`briefs/${params.briefId}/cancelar`, params)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    existsBriefByClienteAccion ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_VALIDACION_EXISTS');

            let queryString = '?clienteId='+ params.clienteId
                + '&accion='+ params.accion;
        
            apiAxios.get('briefs/exists' + queryString)
                .then(res => {
                    let status = parseInt(res.status);

                    if (status == 200) {
                        commit('SET_VALIDACION_EXISTS', true);
                        resolve();
                    } else if (status == 204) {
                        commit('SET_VALIDACION_EXISTS', false);
                        resolve();
                    } else {
                        reject('Se produjo un error al validar la información del brief de diseño.');
                    }
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getUsuariosBrief ( { commit }, briefId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_SELECCION_USUARIOS', briefId);

            apiAxios.get(`briefs/${briefId}/usuarios`)
                .then(res => {
                    commit('SET_SELECCION_USUARIOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    setUsuariosBrief ( { state } ) {
        return new Promise((resolve, reject) => {
            let usuarios = state.usuarios
                .filter(t => t.asignado)
                .map(t => ({
                    usuarioId: t.usuarioId,
                    usuarioRolId: t.usuarioRolId
                }));
                
            let usuariosBrief = {
                usuarios
            }

            apiAxios.post(`briefs/${state.briefId}/usuarios`, usuariosBrief)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getBriefsByPresupuesto ( { commit }, presupuestoInternoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_SEARCH_LIST');

            apiAxios.get(`briefs/presupuesto/${presupuestoInternoId}`)
                .then(res => {
                    commit('SET_SEARCH_LIST', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    getList ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            let queryString = '';

            if ((/true/i).test(state.filtroNumero)) {
                if (state.numero != 0) {
                    queryString = '?numero=' + state.numero;
                } else {
                    queryString = '?numero=-1';
                }
            } else if ((/true/i).test(state.filtroPresupuesto)) {
                if (state.numeroPI != 0) {
                    queryString += (queryString ? '&' : '?') + 'presupuestoNumero=' + state.numeroPI;
                }
                if (state.numeroPI == 0) {
                    queryString += (queryString ? '&' : '?') + 'presupuestoNumero=-1';
                }
            } else {
                queryString += '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                    + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD')
                    + '&sortByDescending='+ state.sortByDescending;

                if (state.cliente) {
                    if (state.cliente.id != 0) {
                        queryString += '&clienteId=' + state.cliente.id;
                    }
                }
                if ((/true/i).test(state.incluirCerrados)) {
                    queryString += '&incluirCerrados=true';
                }
            }
                
            apiAxios.get('briefs/list' + queryString)
                .then(res => {
                    commit('SET_LIST', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}